import 'underscore';
import userData from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/services/user-data';

var initialStateBankIdRequirementExcluded;
var initialState;

const initModuleGlobals = () => {
    if (initialState) {
        return initialState;
    }
    initialStateBankIdRequirementExcluded = {
        showBankIdProgress: false,
        showBankIdError: false,
        authenticationStarted: false,
        errorMessage: ''
    };
    initialState = _.assign({}, initialStateBankIdRequirementExcluded, {
        initialBankIdForBinRequired: userData.initialBankIdForBinRequired,
        supportsVerification: userData.supportsVerification,
        bankIdForBinRequired: userData.bankIdForBinRequired,
        maskedPersonalNumber: userData.maskedPersonalNumber
    });
};

export default (state, action) => {
    initModuleGlobals();
    state = state || initialState;
    switch (action.type) {
        case 'RESET_BANKID_AUTHENTICATION_STATE':
            return _.assign({}, initialState, {
                initialBankIdForBinRequired: state.initialBankIdForBinRequired,
                bankIdForBinRequired: state.bankIdForBinRequired,
                supportsVerification: state.supportsVerification
            });
        case 'SHOW_BANKID_PROGRESS':
            return _.assign({}, state, { showBankIdProgress: true });
        case 'SET_BANKID_AUTHENTICATION_STARTED':
            return _.assign({}, state, { authenticationStarted: true });
        case 'SET_BANKID_AUTHENTICATION_ENDED':
            return _.assign({}, state, { authenticationStarted: false });
        case 'SET_BANKID_ERROR_MESSAGE':
            return _.assign({}, state, {
                errorMessage: action.payload,
                showBankIdError: true
            });
        case 'SET_BANKID_NOT_REQUIRED':
            return _.assign({}, state, {
                initialBankIdForBinRequired: false,
                bankIdForBinRequired: false,
                supportsVerification: false
            });
        default:
            return state;
    }
};
